import 'slick-carousel';
import g from './utils/globalVariables.es6';

const GALLERY_SELECTOR = '.js-gallery';
const GALLERY_NAV_SELECTOR = '.js-gallery-nav';
const ARROW_LEFT_MARKUP =
  '<button type="button" class="slick-prev slick-arrow"><svg class="icon icon-angle-left"><use xlink:href="#icon-angle-left"></use></svg></button>';
const ARROW_RIGHT_MARKUP =
  '<button type="button" class="slick-next slick-arrow"><svg class="icon icon-angle-right"><use xlink:href="#icon-angle-right"></use></svg></button>';
let gallerySettings = {
  infinite: false,
  mobileFirst: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  asNavFor: '.slider-nav',
  prevArrow: ARROW_LEFT_MARKUP,
  nextArrow: ARROW_RIGHT_MARKUP,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: false,
      },
    },
  ],
};
let galleryNavSettings = {
  infinite: false,
  slidesToShow: 6,
  slidesToScroll: 1,
  focusOnSelect: true,
  prevArrow: ARROW_LEFT_MARKUP,
  nextArrow: ARROW_RIGHT_MARKUP,
};

const init = () => {
  if (g.$body.css('direction') == 'rtl') {
    gallerySettings.rtl = true;
    galleryNavSettings.rtl = true;
  }
  initGallery(GALLERY_SELECTOR, gallerySettings);
  initGallery(GALLERY_NAV_SELECTOR, galleryNavSettings);
};

const initGallery = (gallerySelector, sliderSettings) => {
  $(gallerySelector).each((index, gallery) => {
    let $gallery = $(gallery);
    let galleryTargetSelector = $gallery.data('target');

    if ($(galleryTargetSelector).length > 0) {
      sliderSettings.asNavFor = galleryTargetSelector;
    }

    $gallery.slick(sliderSettings);
  });
};

export default init;
